export const removeBaseUrl = (url: string, baseUrl: string): string => {
  const normalizedBase = baseUrl.replace(/\/+$/, '');
  return url.startsWith(normalizedBase) ? url.replace(normalizedBase, '') : url;
};
